import { Component } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { Network } from '@capacitor/network';
import { Platform, ToastController } from '@ionic/angular';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { NotificationService } from '@core/services/notification/notification.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  private noNetworkToast: HTMLIonToastElement | null = null;
  private isDismissedTemporarily: boolean = false;

  constructor(
    private platform: Platform,
    private toastController: ToastController,
    private notificationService: NotificationService,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusNetwork();
      this.lockOrientation();
      // Before welcome routes: a tap that opened the app is retained until then.
      this.notificationService.initListeners();
    });
  }

  async lockOrientation() {
    this.platform.ready().then(() => {
      if (this.platform.is('capacitor')) {
        ScreenOrientation.lock({ orientation: 'portrait' });
      }
    });
  }

  async statusNetwork() {
    const status = await Network.getStatus();
    this.handleNetworkChange(status.connected);

    Network.addListener('networkStatusChange', (status) => {
      this.handleNetworkChange(status.connected);
    });
  }

  async handleNetworkChange(isConnected: boolean) {
    if (isConnected) {
      this.isDismissedTemporarily = false;
      if (this.noNetworkToast) {
        await this.noNetworkToast.dismiss();
        this.noNetworkToast = null;
      }
      return;
    }

    if (this.isDismissedTemporarily) return;
    if (this.noNetworkToast) return;
    this.noNetworkToast = await this.toastController.create({
      message: 'No tienes conexión a internet.',
      header: 'Sin conexión',
      position: 'top',
      mode: 'ios',
      color: 'danger',
      duration: 0,
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel',
          handler: () => {
            this.noNetworkToast = null;
            this.isDismissedTemporarily = true;

            setTimeout(async () => {
              this.isDismissedTemporarily = false;
              const status = await Network.getStatus();
              this.handleNetworkChange(status.connected);
            }, 5000);
          }
        }
      ]
    });
    
    await this.noNetworkToast.present();
  }

}
